export default __webpack_public_path__ + "static/media/microsoft.17f94167.png";